import React from 'react';
import Svg, {
  Circle,
  Defs,
  FeBlend,
  FeFlood,
  FeGaussianBlur,
  Filter,
  G,
  Path,
} from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function CardFrozenVisual({
  iconColor,
  iconAccessibilityLabel,
}: Omit<IconProps, 'iconKey'>) {
  const iconSize = 48;
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 48 48"
    >
      <G filter="url(#filter0_f_36451_2039)">
        <Circle
          cx="24"
          cy="23.9999"
          r="20"
          fill={iconColor}
          fillOpacity="0.4"
        />
      </G>
      <Path
        d="M23.3333 15.8489V13.3334H24.6667V15.8489L26.5571 14.1685L27.4429 15.165L24.6667 17.6328L24.6667 23.6153L30.2804 26.8564L33.8057 25.686L34.2258 26.9514L31.8254 27.7484L34.0038 29.0061L33.3372 30.1608L31.1587 28.9031L31.6688 31.3804L30.3628 31.6493L29.6138 28.0111L24.6667 25.1549L24.6667 30.8674L27.4429 33.3352L26.5571 34.3317L24.6667 32.6513V35.1668H23.3333V32.6513L21.4429 34.3317L20.5571 33.3352L23.3333 30.8674L23.3333 25.1547L18.8191 27.761L18.0701 31.3992L16.7641 31.1303L17.2742 28.653L15.0957 29.9107L14.4291 28.756L16.6075 27.4983L14.207 26.7013L14.6271 25.4359L18.1524 26.6063L22.6665 24.0001L18.1524 21.3939L14.6271 22.5643L14.207 21.2989L16.6075 20.5019L14.429 19.2442L15.0957 18.0895L17.2741 19.3472L16.7641 16.8699L18.07 16.601L18.8191 20.2392L23.3333 22.8455L23.3333 17.6328L20.5571 15.165L21.4429 14.1685L23.3333 15.8489Z"
        fill={iconColor}
      />
      <Path
        d="M33.3373 17.8393L31.1588 19.0971L31.6689 16.6197L30.3629 16.3509L29.6139 19.989L25.6641 22.2695L26.9974 23.0393L30.2806 21.1437L33.8058 22.3141L34.226 21.0487L31.8255 20.2518L34.0039 18.994L33.3373 17.8393Z"
        fill={iconColor}
      />
      <Defs>
        <Filter
          id="filter0_f_36451_2039"
          x="0"
          y="-0.00012207"
          width={iconSize}
          height={iconSize}
          filterUnits="userSpaceOnUse"
        >
          <FeFlood floodOpacity="0" />
          <FeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" />
          <FeGaussianBlur stdDeviation="2" />
        </Filter>
      </Defs>
    </Svg>
  );
}
